module.exports = require('./helpers/bundle-url').getBundleURL('23LRb') + "logo.c51670a8.svg";